import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue'
import {
  YAGISH_LOGO_SRC,
  resolveCcLogoView
} from '@/utils/realtime-transfer/careerconnectionLogo'


export default /*#__PURE__*/_defineComponent({
  __name: 'CareerconnectionMediaLogo',
  props: {
    mediaLogo: { default: '' },
    mediaName: { default: '' },
    fallbackSrc: { default: '' }
  },
  emits: ["load"],
  setup(__props: any, { emit }: { emit: ({ (e: 'load', event: Event): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { mediaLogo: string, mediaName: string, fallbackSrc: string };

/**
 * キャリコネクションの「連携先の企業ロゴ × yagish ロゴ」。
 * RT1.0 ダイアログと完了画面の DL バナーで共通に使う（presentational）。
 */




const yagishLogoSrc = YAGISH_LOGO_SRC
const mediaLogoFailed = ref(false)
// 媒体が変わったら読み込み失敗の記録を戻す
watch(
  () => props.mediaLogo,
  () => {
    mediaLogoFailed.value = false
  }
)

const view = computed(() =>
  resolveCcLogoView(props.mediaLogo, props.fallbackSrc, mediaLogoFailed.value)
)

return { __sfc: true,props, emit, yagishLogoSrc, mediaLogoFailed, view }
}

})